import { AlertCircle } from "@sede-enterprise/shell-ds-react-framework/build/esm/components/Icon/components";

export const messagePredictions = (msescore, r2score, msewtscore, r2wtscore) => {

    const warning1 = (
        <span className="warning">
            <AlertCircle htmlColor="#fdbc40" /> Measured and/or predicted corrosion
            rate unavailable within the time period used for calculating score(s)
        </span>
    );
    const warning2 = (
        <span className="warning">
            <AlertCircle htmlColor="#fdbc40" /> Measured and/or predicted wall
            thickness unavailable within the time period used for calculating score(s)
        </span>
    );

    if (
        (msescore === "NA" || r2score === "NA") &&
        (msewtscore === "NA" || r2wtscore === "NA")
    ) {
        return (
            <div className="column">
                {warning1}
                {warning2}
            </div>
        );
    } else if (msescore === "NA" || r2score === "NA") {
        return warning1;
    } else if (msewtscore === "NA" || r2wtscore === "NA") {
        return warning2;
    }
};